import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import GaugeChart from "react-gauge-chart";

export function ChartMargin({ marginWalletData }) {
  const theme = useTheme();

  const chartStyle = {
    width: 180,
    marginRight: "auto",
  };

  return (
    <Grid item xs={12}>
      <GuageChartWrapper>
        <GaugeChart
          id="gauge-margin"
          nrOfLevels={5}
          arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
          colors={[
            theme.palette.modules.colorChartMarginGreen,
            theme.palette.modules.colorChartMarginYellow,
            theme.palette.modules.colorChartMarginOrange,
          ]}
          percent={
            marginWalletData?.marginLevel
              ? marginWalletData?.marginLevel / 100
              : 0
          }
          arcPadding={0}
          textColor={theme.palette.modules.colorChartMarginRed}
          arcWidth={0.1}
          hideText={true}
          style={chartStyle}
        />

        <Box>
          <TypographyStyle component="span">
            {marginWalletData?.marginLevel}%
          </TypographyStyle>

          <Typography variant="h6" textAlign={"center"} mb={3} color={"text.primary"}>
            Margin Level
          </Typography>
        </Box>
      </GuageChartWrapper>
    </Grid>
  );
}
const TypographyStyle = styled(Typography)(({ theme }) => ({
  justifyContent: "center",
  display: "flex",
  alignItems: "center",
  color: theme.palette.text.primary,
  "&::before": {
    content: '""',
    width: "250px",
    height: "10px",
    background: theme.palette.modules.backgroundIconNotification,
    filter: "blur(12px)",
    position: "absolute",
    zIndex: 0,
  },

}));

const GuageChartWrapper = styled(Box)(({ theme }) => ({
  width: "fit-content",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down('sm')]: {
    margin: "auto"
  }
}));
export default ChartMargin;
